module.exports = __webpack_public_path__ + "img/icon-arrow-down.e49b1ca5.svg";